exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modal-add-po-item label,\n#modal-add-po-item legend {\n  font-size: 14px !important;\n  margin-bottom: 0.5rem !important;\n}\n", ""]);

// exports
